import Footer from "components/footerUser";
import Header from "components/header";
import React from "react";
// import Header from "../../components/Header";
import BookListItem from "../../components/BookListItem";
import useStyles from './style';
import 'assets/css/About.css';
// import Footer from "../../components/Footer";

const AboutUs = () => {
    const styles = useStyles();
    const data = [
        {
          menu: 'Tentang Persona',
          content: (
            <div className="book">
              <h4>Tentang Persona</h4>
              <p>Berdasarkan analisa dan penelitian terkait Delapan Aksara, Astrologi dengan analitik metodologi dari Persona, kami bertujuan untuk dapat memberikan Anda informasi yang bersifat hiburan namun mendalam dan komprehensif tentang diri Anda, hubungan Anda, kecocokan dengan orang lain, gaya bekerja Anda, kehidupan sosial dan pribadi Anda, kehidupan cinta Anda dan pentingya berbagai waktu dalam keseharian Anda.</p>
              <p>Kami tidak membuat peramalan atau penilaian, melainkan memberi Anda informasi data yang bersifat terbuka dalam potret Anda.</p>
              <p>Dengan lebih memahami kekuatan dan tantangan Anda sendiri, serta teman dan pasangan Anda, Anda akan semakin berdaya untuk membuat pilihan terbaik bagi diri Anda sendiri.</p>
              <p>Idealnya, apa yang Anda temukan tentang diri Anda akan mencerminkan hal-hal yang sudah Anda ketahui, tetapi mungkin belum Anda terima atau pahami sebelumnya</p>
              <p>Kami percaya bahwa kita semua adalah bagian dari bagan-bagan dan pilhan yang lebih besar, dan keberadaan Anda sangatlah penting.</p>
              <p>Kami harap Anda menikmati.</p>
              <h5>Persona Talenta</h5>
              <p>What's Your Persona?</p>
            </div>
          )
        },
        {
          menu: 'Cara Menggunakan Layanan',
          content: (
            <div className="book">
              <h4>A. Cara menggunakan Persona Talenta:</h4>
              <ol type="1">
                <li>Buka website <a href="/home">https://personatalenta.id/home</a></li>
                <li>Klik <strong>Buat Akun</strong></li>
                <li>⁠⁠Isi form profile, klik <strong>register</strong></li>
                <li>Cek <strong>email verifikasi</strong> ke alamat email yang diisikan didalam form. Klik button <strong>verifikasi email saya</strong></li>
                <li>Kembali ke <a href="/home">https://personatalenta.id/home</a> dan Klik <strong>Login</strong></li>
              </ol>
              <h4>B. Cara membeli layanan Persona Talenta:</h4>
              <ol type="1">
                <li>Masuk ke website <a href="/home">https://personatalenta.id/home</a></li>
                <li>⁠⁠Klik Login, masukan username dan password.</li>
                <li>⁠⁠Setelah Login akan masuk ke <strong>Dashboard Profile</strong>.</li>
                <li>⁠⁠Untuk membeli layanan, selanjutnya Pilih Service yang akan dibeli, misal: <strong>Service</strong> : <strong>Profiling Book - Feature : Complete Profiling Book</strong> , geser ke kanan pada kolom menu Action klik button <strong>Beli</strong>.</li>
              </ol>
              <h4>C. Cara Membayar Layanan yang akan dibeli:</h4>
              <ol type="1">
                <li>⁠Setelah klik tombol <strong>Beli</strong> akan diarahkan ke halaman Layanan yang dipilih dengan kelengkapan informasinya.</li>
                <li>⁠⁠Dihalaman informasi Layanan dan Harga, mulai proses Select Service : klik <strong>Buy Now</strong> sesuai dengan layanan yang dipilih.</li>
                <li>⁠⁠Selanjutnya ke proses Confirm Order : pada kolom <strong>Pilih Pembayaran</strong>, klik <strong>QR Code</strong>, lanjut ke kolom <strong>Pilih Metoda Pembayaran</strong>, klik <strong>kotak logo QRIS</strong> akan muncul button <strong>lanjut bayar</strong>, klik button lanjut bayar maka akan muncul <strong>QR Bayar</strong>, selanjutnya scan QR Bayar untuk melakukan pembayaran.</li>
                <li>⁠⁠Setelah selesai pembayaran akan di redirect ke <strong>Dashboard Purchase History</strong> dengan list Service Feature yang sudah dibayar.</li>
                <li>⁠⁠Klik button <strong>icon download</strong> atau <strong>web view</strong> sesuai dengan layanan yang dibeli dan yang anda inginkan, untuk icon <strong>download</strong> maka file pdf yang dibeli akan didownload.</li>
                <li>⁠⁠Enjoy Reading Your Profilling.</li>
              </ol>
            </div>
          )
        },
      ]
    
    return (
        <div className={styles.app}>
            <Header />
            <div className={styles.containerListItem}>
                <BookListItem data={data}/>
            </div>
            <Footer />
        </div>
    )
}

export default AboutUs;